import request from "../request";

/**
 * Получить все переводы
 * @return {Promise}
 */
export const getAllDictionary = lang => {
	return request({
		url: "/language/get-all-dictionary",
		type: "GET",
		needOverlay: false,
		data: {
			lang: lang,
		},
	});
};
